import { linksToWire } from './dictionary'

// ─── One-step lesson creation (2026-10-13) ────────────────────────────────────
//
// CreateForm's submit, kept out of the component so the rules are testable
// without a DOM: what the create call carries, which upload a picked file
// goes to, and that a retry after a failed upload never makes a second lesson.

/**
 * The create body: a title, the one sentence, level and order. No Persian
 * title, translation, slug or description — the server derives the slug and
 * stores the Persian columns empty.
 */
export function lessonDto(form) {
  return {
    titleEn: form.titleEn.trim(),
    level: form.level,
    displayOrder: Number(form.displayOrder),
    sentences: [{ textEn: form.textEn.trim(), wordLinks: linksToWire(form.wordLinks) }],
  }
}

const VIDEO_EXT = /\.(mp4|m4v|mov|webm)$/
const AUDIO_EXT = /\.(mp3|m4a|aac|wav|ogg|oga|opus|weba)$/

/**
 * `'video'`, `'audio'`, or null for a file that is neither. A lesson takes
 * one of the two (owner, 2026-10-13): a video, whose sound the server takes
 * as the exercise's audio, or a voice file that is that audio — the learner
 * then shadows whichever there is. The browser's type decides; the name is
 * the fallback for the files some browsers leave untyped.
 */
export function mediaKind(file) {
  const type = (file?.type ?? '').toLowerCase()
  if (type.startsWith('video/')) return 'video'
  if (type.startsWith('audio/')) return 'audio'
  const name = (file?.name ?? '').toLowerCase()
  if (VIDEO_EXT.test(name)) return 'video'
  if (AUDIO_EXT.test(name)) return 'audio'
  return null
}

/**
 * Create the lesson (unless `created` already is one, from an earlier try
 * whose upload failed), tell `onDraft` about it straight away, then upload
 * the file — a video to upload-video, a voice file as the one sentence's
 * audio — and resolve with the lesson as the upload left it. A file that is
 * neither is refused before anything is created. A failed upload rejects
 * after `onDraft` has run, so the caller can hold on to the lesson.
 */
export async function createWithMedia({ created, form, file, onDraft, onProgress }, api) {
  const kind = mediaKind(file)
  if (!kind) throw new Error('فایل باید ویدیو یا صدا باشد.')
  let lesson = created
  if (!lesson) {
    lesson = await api.createLesson(lessonDto(form))
    onDraft(lesson)
  }
  return kind === 'video'
    ? api.uploadVideo(lesson.id, file, onProgress)
    : api.uploadAudio(lesson.id, 0, file, onProgress)
}
